import ColumnLayout from '@molecules/ColumnLayout';
import ContactForm from '@organisms/ContactForm';
import type { ReactElement } from 'react';

import { ContactFormWrapper } from './ContactPageView.styled';
import type { ContactPageViewProps } from './ContactPageView.types';

export const ContactPageView = ({
  columnLayout,
}: ContactPageViewProps): ReactElement => (
  <ColumnLayout {...columnLayout} hideBreadcrumbs>
    <ContactFormWrapper>
      <ContactForm />
    </ContactFormWrapper>
  </ColumnLayout>
);
